import { render, staticRenderFns } from "./InfoCompany.vue?vue&type=template&id=581de62a"
import script from "./InfoCompany.vue?vue&type=script&lang=js"
export * from "./InfoCompany.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports